/* eslint-disable */
import { Box, Button, Divider, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState, useRef, useCallback } from "react";
import styles from "./AmarantComponent.module.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { listFines } from "../../actions/amarantFields";
import { connect } from "react-redux";
import moment from "moment";
import { filterByProp } from "../../utils/helperFunctions";
import {
  getBaseCurrencyBySwitchDate,
  getDisplayCurrencyOrderBySwitchDate,
  getDualAmountsFromBase,
  formatMoney,
  getCurrencySymbol,
  toNumberOrNull,
} from "../../utils/currency";

const columnKeys = [
  "amarant:colName",
  "amarant:colFineNo",
  "amarant:colAmount",
  "amarant:colPaymentReceived",
  "amarant:colPaymentDate",
  "amarant:colPaymentTime",
];

function FinesComponent({ fines, listFines, customerID }) {
  const { t } = useTranslation();
  const [filter, setFilter] = useState("");
  const [allFines, setAllFines] = useState([]);
  const now = new Date();
  const baseCurrency = getBaseCurrencyBySwitchDate(now);
  const displayOrder = getDisplayCurrencyOrderBySwitchDate(now);

  const renderAmount = (amount) => {
    const dual = getDualAmountsFromBase(amount, baseCurrency);
    const primary = displayOrder[0];
    const secondary = displayOrder[1];
    const primaryAmount = dual?.[primary];
    const secondaryAmount = dual?.[secondary];

    if (toNumberOrNull(primaryAmount) === null) return "-";

    return (
      <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.1 }}>
        <b>{`${formatMoney(primaryAmount)} ${getCurrencySymbol(primary)}`}</b>
        {toNumberOrNull(secondaryAmount) !== null && (
          <Typography variant="caption" color="text.secondary">
            {`≈ ${formatMoney(secondaryAmount)} ${getCurrencySymbol(secondary)}`}
          </Typography>
        )}
      </Box>
    );
  };

  useEffect(() => {
    listFines({
      //customerSupportId: "6231bc7bc8696d0016d4af13",
      customerSupportId: customerID,
    });
  }, []);

  return (
    <div style={{ overflowY: "auto", height: "95%", width: "100%" }}>
      {window.innerWidth < 900 ? (
        <>
          <div className={styles["tabs-container"]} style={{ padding: "0px" }}>
            {fines.map((fine, i) => {
              return (
                <div
                  className={styles["row-container"]}
                  style={{ marginTop: "5%", display: "block", height: "unset" }}
                  key={i}
                >
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnKeys[0])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {fine.drivingLicense.fullName}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnKeys[1])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {fine.document}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnKeys[2])}
                    </p>
                    <div style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {renderAmount(fine.price)}
                    </div>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnKeys[3])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {fine.paid ? t("yes") : t("no")}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnKeys[4])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {moment(fine.paymentDate || fine.updatedAt).format("DD.MM.YYYY")}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnKeys[5])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {moment(fine.paymentDate || fine.updatedAt).format("HH:mm")}
                    </b>
                  </div>
                  <Divider />
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <>
          <div className={styles["columns-container"]}>
            <div className={styles["upper-names"]}>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "13%", cursor: "pointer" }}
                onClick={() => {
                  if (filter === "name") {
                    setFilter("reverseName");
                    filterByProp(fines, "reversePlate", "user");
                  } else {
                    setFilter("name");
                    filterByProp(fines, "plate", "user");
                  }
                }}
              >
                <p>{t(columnKeys[0])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "8%", cursor: "pointer" }}
                onClick={() => {
                  if (filter === "fineNumber") {
                    setFilter("reverseFineNumber");
                  } else {
                    setFilter("fineNumber");
                  }
                }}
              >
                <p>{t(columnKeys[1])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "8%", cursor: "pointer" }}
                onClick={() => {
                  if (filter === "amount") {
                    setFilter("reverseAmount");
                  } else {
                    setFilter("amount");
                  }
                }}
              >
                <p>{t(columnKeys[2])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "8%", cursor: "pointer" }}
                onClick={() => {}}
              >
                <p>{t(columnKeys[3])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "10%", cursor: "pointer" }}
                onClick={() => {
                  if (filter === "paidDate") {
                    setFilter("reversePaidDate");
                    filterByProp(fines, "reverseCreatedAt", "updatedAt");
                  } else {
                    setFilter("paidDate");
                    filterByProp(fines, "createdAt", "updatedAt");
                  }
                }}
              >
                <p>{t(columnKeys[4])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "10%", cursor: "pointer" }}
                onClick={() => {
                  if (filter === "paidTime") {
                    setFilter("reversePaidTime");
                    fines.sort((a, b) => {
                      var c = moment(a.updatedAt).format("HH:mm");
                      var d = moment(b.updatedAt).format("HH:mm");
                      if (!c && !d) {
                        return 0;
                      } else if (c && !d) {
                        return 1;
                      } else if (!c && d) {
                        return -1;
                      } else {
                        const value1 = c.toString().toUpperCase();
                        const value2 = d.toString().toUpperCase();
                        if (value1 < value2) {
                          return 1;
                        } else if (value1 > value2) {
                          return -1;
                        } else {
                          return 0;
                        }
                      }
                    });
                  } else {
                    setFilter("paidTime");
                    fines.sort((a, b) => {
                      var c = moment(a.updatedAt).format("HH:mm");
                      var d = moment(b.updatedAt).format("HH:mm");
                      if (!c && !d) {
                        return 0;
                      } else if (c && !d) {
                        return -1;
                      } else if (!c && d) {
                        return 1;
                      } else {
                        const value1 = c.toString().toUpperCase();
                        const value2 = d.toString().toUpperCase();
                        if (value1 < value2) {
                          return -1;
                        } else if (value1 > value2) {
                          return 1;
                        } else {
                          return 0;
                        }
                      }
                    });
                  }
                }}
              >
                <p>{t(columnKeys[5])}</p>
              </div>
            </div>
          </div>
          <div className={styles["tabs-container"]} style={{}}>
            {fines.map((outterFine, i) => {
              return outterFine?.fines?.map((fine, j) => {
                return (
                  <div
                    className={styles["row-container"]}
                    style={{ width: "100%", minHeight: "50px", height: "auto" }}
                  >
                    <div className={styles["data"]} style={{ width: "13%" }}>
                      <b>{outterFine.drivingLicense.fullName}</b>
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    <div className={styles["data"]} style={{ width: "8%" }}>
                      <b>{fine.document}</b>
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    <div className={styles["data"]} style={{ width: "8%" }}>
                      {renderAmount(fine.price)}
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    <div className={styles["data"]} style={{ width: "8%" }}>
                      <b>{outterFine.paid ? t("yes") : t("no")}</b>
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    <div className={styles["data"]} style={{ width: "10%" }}>
                      <b>{moment(fine.paymentDate || fine.updatedAt || outterFine.updatedAt).format("DD.MM.YYYY")}</b>
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    <div className={styles["data"]} style={{ width: "10%" }}>
                      <b>{moment(fine.paymentDate || fine.updatedAt || outterFine.updatedAt).format("HH:mm")}</b>
                    </div>
                  </div>
                );
              });
            })}
          </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  fines: state.amarantFields.fines,
});

const mapDispatchToProps = (dispatch) => ({
  listFines: (payload) => dispatch(listFines(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FinesComponent);
